<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-comments mr-4"></i>Notes</span>
        </h1>
        <main ref="notescontainer" class="flex flex-1 flex-col mb-2 pr-4 overflow-y-scroll overflow-x-hidden" @mouseover="(e) => e.target.focus({ focusVisible: false })">
            <div v-for="note in notes" :key="note.id" class="max-w-md mb-4" :class="note.created_by.is_you ? 'ml-8 self-end' : 'mr-8 self-start'">
                <div
                    class="rounded-xl border p-3 flex flex-row last:mb-0 max-w-md"
                    :class="{
                        'bg-brand border-brand-dark text-white': note.created_by.is_you,
                        'bg-gray-50 border-gray-300 text-brand': ! note.created_by.is_you
                    }"
                >
                    <div class="mr-3 flex-shrink-0">
                        <img
                            class="rounded h-6 w-6"
                            :src="(note.created_by || {}).avatar"
                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                        />
                    </div>
                    <div>
                        <h3 class="text-xs font-bold" :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'" v-text="note.created_by.name"></h3>
                        <div class="whitespace-pre-wrap" :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'" v-text="note.note"></div>
                    </div>
                </div>
                <div :class="note.created_by.is_you ? 'text-right' : 'text-left'" class="mt-1.5 text-xs">
                    <span class="inline-block text-gray-400 hover:text-gray-500 cursor-pointer" :title="note.created_at_formatted">{{ note.created_at_human }}</span>
                </div>
            </div>
        </main>
        <aside class="">
            <div class="mt-0 flex rounded-md shadow-sm">
                <div class="relative flex items-stretch flex-grow focus-within:z-10">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <img
                            class="rounded w-6 h-6"
                            :src="avatar_url"
                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                        />
                    </div>
                    <input
                        v-model="note"
                        type="text"
                        class="focus:ring-brand focus:border-brand block w-full mb-0 rounded-none rounded-l-md pl-12 sm:text-sm border-gray-300"
                        placeholder="Enter note here..."
                        @keyup.enter="addNote()"
                    >
                </div>
                <button @click.prevent="addNote()" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
                    <i class="fas fa-caret-right"></i>
                    <span>Send</span>
                </button>
            </div>
        </aside>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: {
        dashboardData:Object,
        dashboardProps:Object,
    },
    data() {
        return {
            notes: [],
            note: ''
        }
    },
    computed: {
        avatar_url(){
            return appData.user.avatar_url;
        }
    },
    methods: {
        scrollToBottom(){
            let container = this.$refs.notescontainer;

            // We need to delay this a little bit to allow the browser time to render
            // the new data before we actually scroll to the bottom of the container.
            setTimeout(function () {
                container.scrollTop = container.scrollHeight;
            }, 100);
        },
        addNote() {
            let that = this;
            let note = this.note;
            this.note = '';
            axios.post(this.postUrl(), {note: note})
                .then(response => {
                    that.notes.push(response.data.data);
                    that.scrollToBottom();
                });
        },
        getNotes() {
            let that = this;
            axios.get(this.getUrl())
                .then(response => {
                    that.notes = response.data.data;
                    that.scrollToBottom();
                });
        },
        getUrl() {
            return route('api.v1.packages.notes.index',this.dashboardData.legacyPackageItem.id)
        },
        postUrl() {
            return route('api.v1.packages.notes.store',this.dashboardData.legacyPackageItem.id)
        }
    },
    mounted() {
        this.getNotes();
    }
}

</script>